import { Button, Tooltip } from "@/components/ui";
import { useConfigCatFeatureFlag } from "@/network/useConfigCatFeatureFlag";
import { BadgeDollarSign } from "lucide-react";
import { useState } from "react";
import { PrescriptionBenefitsModal } from "./PrescriptionBenefitsModal";

export interface PharmacyInfo {
  name?: string;
  address?: {
    city?: string;
    line?: string[];
    postalCode?: string;
    state?: string;
  };
  telecom?: Array<{ value?: string }>;
}

export interface PrescriptionBenefitsButtonProps {
  ndc: string;
  medicationName: string;
  pharmacyId: number | null;
  quantity: number | null;
  daysSupply: number | null;
  dispenseUnitTypeId: number | null;
  pharmacy?: PharmacyInfo | null;
  disabled?: boolean;
}

export const PrescriptionBenefitsButton = (
  props: PrescriptionBenefitsButtonProps,
) => {
  const [isOpen, setIsOpen] = useState(false);

  const { data: isPrescriptionBenefitsEnabled } = useConfigCatFeatureFlag(
    "emr-surescripts-prescription-benefits",
  );

  if (!isPrescriptionBenefitsEnabled) return null;

  const tooltipText = props.disabled
    ? "Missing required fields (pharmacy, quantity, days supply, dispense unit)"
    : "View Benefits";

  return (
    <>
      <Tooltip
        tooltipContentText={tooltipText}
        side="bottom"
        triggerClassName="flex items-center"
      >
        <Button
          variant="icon"
          className="m-0 p-0"
          onClick={() => !props.disabled && setIsOpen(true)}
          aria-label="View prescription benefits"
          disabled={props.disabled}
        >
          <BadgeDollarSign
            className={`h-4 w-4 ${props.disabled ? "stroke-muted" : "stroke-link"}`}
          />
        </Button>
      </Tooltip>
      <PrescriptionBenefitsModal
        open={isOpen}
        onOpenChange={setIsOpen}
        {...props}
      />
    </>
  );
};
